import _regeneratorRuntime from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import qualificationsDialog from '@/components-v2/qualificationsDialog.vue';
import { AccountStorage } from "@services/account";
import { mapActions } from "vuex";
import Pager from '@/components-v2/pager';
import qualificationsPopup from '@mixin/qualificationsPopup';
var accountStorage = new AccountStorage();
export default {
  components: {
    Pager: Pager,
    qualificationsDialog: qualificationsDialog
  },
  data: function data() {
    return {
      pageInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      current: 1,
      // 页码
      perPage: 10,
      rangeBefore: 3,
      rangeAfter: 1,
      cartList: [],
      // 收藏列表数据
      selectAll: false,
      id: null
    };
  },
  mixins: [qualificationsPopup],
  computed: {
    // 是否禁用提交按钮
    hasChecked: function hasChecked() {
      return this.cartList.some(function (item) {
        // this.ischeckNum = item.isCheckedName
        return item.isCheckedName === true;
      });
    }
  },
  created: function created() {
    this.getEnshrineList();
  },
  methods: _objectSpread(_objectSpread({}, mapActions(['findCardList'])), {}, {
    // 商品列表
    getEnshrineList: function getEnshrineList() {
      var _this = this;
      var data = {
        page: this.current,
        pageSize: this.pageInfo.pageSize
      };
      var url = "/pjyy-deepexi-product-center/api/v1/product/productCollection/pageList";
      this.$getHttpClient().post(url, data).then(function (res) {
        var arr = [];
        arr = res.data.data.list;
        _this.pageInfo.total = res.data.data.total;
        _this.pageInfo.pageSize = res.data.data.pageSize;
        _this.pageInfo.pageNum = _this.current;
        _this.cartList = [];
        arr.forEach(function (item) {
          _this.cartList.push(_objectSpread({
            isCheckedName: false
          }, item));
        });
        _this.cartList.forEach(function (item) {
          if (!item.isCheckedName) {
            _this.selectAll = false;
          }
        });
      });
    },
    // 分页
    handleChange: function handleChange(val) {
      this.current = val;
      this.cartList = [];
      this.getEnshrineList();
    },
    // 全选
    getSelectAll: function getSelectAll(val) {
      this.selectAll = !this.selectAll;
      this.cartList.forEach(function (item) {
        // if(item.isInvalid) {
        item.isCheckedName = !item.isCheckedName;
        // }
      });
    },
    // 单个勾选
    getSelectItem: function getSelectItem() {
      var arr = [];
      this.cartList.forEach(function (item) {
        if (item.isInvalid) {
          arr.push(item);
        }
      });
      this.selectAll = arr.every(function (item) {
        return item.isCheckedName === true;
      });
    },
    //获取用户ID
    getUserId: function getUserId() {
      var userInfo = accountStorage.getCacheUserInfo();
      if (userInfo) {
        return userInfo.userId;
      }
      return;
    },
    // 加入购物车
    addShopping: function addShopping(item) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var URL, data, result, _data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!_this2.qualificationsPopup(1, null, item)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              URL = "/pjyy-deepexi-order-center/api/v1/cart/addGoodsToCartList";
              data = {
                productId: item.productId,
                userId: Number(_this2.getUserId()),
                totalNumber: item.superDiscountProductNum ? item.superDiscountProductNum : 1
              };
              _context.next = 6;
              return _this2.$getHttpClient().post(URL, data);
            case 6:
              result = _context.sent;
              if (!(result.data.code == "200")) {
                _context.next = 14;
                break;
              }
              _data = result.data.data; // 如果有资质过期的数据，显示资质过期弹窗
              if (!(_data.certificateList && _data.certificateList.length)) {
                _context.next = 12;
                break;
              }
              _this2.qualificationsPopup(2, _data);
              return _context.abrupt("return");
            case 12:
              _this2.$messageTip('加入购物车成功', 'success');
              _this2.findCardList();
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    // 取消收藏
    handleCancel: function handleCancel(item) {
      var _this3 = this;
      document.body.parentNode.style.overflow = "hidden";
      this.$confirm('是否确认将商品移除收藏？', '我的收藏').then(function () {
        _this3.id = item.id;
        _this3.handleConfirmDownload();
      });
    },
    // 批量取消收藏
    delCartProduct: function delCartProduct() {
      var _this4 = this;
      var ids = [];
      this.cartList.forEach(function (item) {
        if (item.isCheckedName) {
          ids.push(item.id);
        }
      });
      var data = {
        ids: ids
      };
      // if (this.selectAll) {
      var url = "/pjyy-deepexi-product-center/api/v1/product/productCollection/removeBatch";
      this.$getHttpClient().post(url, data).then(function (res) {
        if (res.data.code === "200") {
          _this4.getEnshrineList();
          _this4.selectAll = false;
        }
      });
      // }
    },
    // 弹窗确定
    handleConfirmDownload: function handleConfirmDownload() {
      var _this5 = this;
      document.body.parentNode.style.overflow = "";
      var url = "/pjyy-deepexi-product-center/api/v1/product/productCollection/remove?id=".concat(this.id);
      this.$getHttpClient().delete(url).then(function (res) {
        if (res.data.code === "200") {
          _this5.getEnshrineList();
        }
      });
    },
    // 跳转到详情页
    toDetail: function toDetail(val) {
      if (val.id || val.productId) {
        this.$router.push({
          name: "v2-detail",
          params: {
            id: val.productId,
            sale: val.notLowerSale
          }
        });
      }
    }
  }),
  updated: function updated() {}
};